import {
  EXPERT_DATA_LOADED,
  EXPERT_DATA_UNLOAD,
  EXPERT_NOT_FOUND,
  UPDATE_EXPERT_DATA,
} from './profilePageActionsTypes';

export const initialState = {
  expertLoaded: false,
  expert: undefined,
  expertNotFound: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EXPERT_DATA_LOADED:
      return {
        ...state,
        expertLoaded: true,
        expert: action.expertData,
        expertNotFound: false,
      };
    case EXPERT_DATA_UNLOAD:
      return initialState;
    case EXPERT_NOT_FOUND:
      return {
        ...initialState,
        expertNotFound: true,
      };
    case UPDATE_EXPERT_DATA:
      return {
        ...state,
        expert: action.expertData,
      };
    default:
      return state;
  }
};
